// import axios from "axios"

export const encrypt = async (data) => {
    try {
        // const token = await auth.currentUser.getIdToken()
        // const { data: encryption } = await axios.post('/encrypt', { data }, {
        //     baseURL: "https://us-central1-bindoo-collectives.cloudfunctions.net/api",
        //     headers: {
        //         "Authorization": `Bearer ${token}`
        //     }
        // })  

        // return encryption
        return data
    } catch(err) {
        return data
    } 
}

export const decrypt = async (data) => {
    try {
        // const token = await auth.currentUser.getIdToken()
        // const { data: decrytion } = await axios.post('/decrypt', { data }, {
        //     baseURL: "https://us-central1-bindoo-collectives.cloudfunctions.net/api",
        //     headers: {
        //         "Authorization": `Bearer ${token}`
        //     }
        // })  

        // return decrytion
        return data
    } catch(err) {
        return {}
    } 
}